/* ============================================================
   Barky Sélecteur d'offre — 3 étapes — v6 (look besti, couleurs Barky)
   Logique identique à v5 ; cartes quantité en layout vertical (image, mois, €/jour).
   ============================================================ */
(function () {
  'use strict';

  const cfg = window.barkyConfig;
  if (!cfg) { console.warn('[Barky] window.barkyConfig manquant.'); return; }

  const form = document.getElementById('barky-selector-form');
  if (!form) return;

  const state = {
    weight: null, recoCount: null, count: null,
    frequency: (cfg.showFrequency === false) ? 'oneoff' : 'subscription',
    cadence: cfg.defaultCadence || 'monthly', flavor: 'poulet'
  };

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const eur = (n) => n.toFixed(2).replace('.', ',') + ' €';

  function tier(count) { return cfg.boxTiers[String(count)] || null; }
  function dose() { const p = cfg.weightProfiles[state.weight]; return p ? p.dose : 1; }

  // ----- ÉTAPE 2 : cartes quantité -----
  function renderBundles() {
    const list = $('[data-bundle-list]');
    if (!list || !state.weight) { if (list) list.innerHTML = ''; return; }
    const profile = cfg.weightProfiles[state.weight];

    list.innerHTML = profile.boxes.map((count) => {
      const t = tier(count);
      if (!t) return '';
      const save = t.compareTotal ? Math.round((t.compareTotal - t.total) / t.compareTotal * 100) : 0;
      const days = t.bouchees / dose();
      const months = Math.max(1, Math.round(days / 30));
      // Coût par JOUR : le prix rapporté au nombre de jours de cure, pas au
      // nombre de bouchées. Un chien moyen en consomme 2/jour, un grand 3/jour.
      const perDay = (t.total / days).toFixed(2).replace('.', ',');
      const isReco = count === state.recoCount;
      const sel = count === state.count;
      const s = count > 1 ? 's' : '';

      // Icone sparkles avant le libelle. fill=currentColor : elle prend le blanc
      // du ruban, et suivrait automatiquement un changement de couleur.
      const spark = '<svg class="barky-ribbon-spark" viewBox="0 0 16 16" width="11" height="11" fill="none" aria-hidden="true" focusable="false">'
        + '<path fill="currentColor" d="M6.4099 2C5.80101 5.35962 5.3074 5.86098 2 6.47948C5.30743 7.09798 5.80101 7.59934 6.4099 10.959C7.01879 7.59934 7.51237 7.09798 10.8198 6.47948C7.51237 5.86098 7.01876 5.35962 6.4099 2Z"/>'
        + '<path fill="currentColor" d="M11.1951 8.30273C10.808 10.4393 10.494 10.7582 8.39062 11.1515C10.494 11.5448 10.808 11.8637 11.1951 14.0003C11.5823 11.8637 11.8963 11.5448 13.9996 11.1515C11.8963 10.7582 11.5824 10.4393 11.1951 8.30273Z"/>'
        + '</svg>';
      const ribbon = isReco ? '<span class="barky-bundle-ribbon">' + spark + '<span>' + (cfg.recoText || 'Recommandé') + '</span></span>' : '';
      const saveBadge = save > 0 ? '<span class="barky-badge barky-badge--sm">-' + save + '%</span>' : '';
      // Test : plus de visuel de pot, on affiche un indicateur radio comme dans
      // le bloc fréquence. L'état coché est piloté en CSS par aria-pressed.
      // cfg.boxImages / cfg.boxImage restent lus par les réglages de section :
      // il suffit de remettre l'ancien markup pour revenir aux images.
      const img = '<span class="barky-bundle-radio" aria-hidden="true"></span>';
      // Prix ramené à la boîte, pas au lot : le client compare à quantité égale.
      const unite = t.total / count;
      const uniteRef = t.compareTotal ? (t.compareTotal / count) : null;
      const suffixe = '<span class="barky-price-unit">/boîte</span>';
      // Prix courant au-dessus, prix barré en dessous, chacun suffixé « /boîte ».
      const priceHtml = (uniteRef)
        ? '<span class="barky-price-strong">' + eur(unite) + suffixe + '</span><span class="barky-price-ref">' + eur(uniteRef) + suffixe + '</span>'
        : '<span class="barky-price-strong">' + eur(unite) + suffixe + '</span>';

      return '' +
        '<button type="button" class="barky-bundle-card' + (isReco ? ' is-reco' : '') + '"' +
          ' data-count="' + count + '" aria-pressed="' + (sel ? 'true' : 'false') + '">' +
          ribbon +
          img +
          '<span class="barky-bundle-info">' +
            '<span class="barky-bundle-line1">' +
              '<span class="barky-bundle-title">' + count + ' boîte' + s + '</span>' + saveBadge +
            '</span>' +
            '<span class="barky-bundle-sub">' + months + ' mois · ' + perDay + ' €/jour</span>' +
          '</span>' +
          '<span class="barky-bundle-prices">' + priceHtml + '</span>' +
        '</button>';
    }).join('');

    $$('.barky-bundle-card', list).forEach((btn) => {
      btn.addEventListener('click', () => selectBox(Number(btn.dataset.count)));
    });
  }

  // ----- ÉTAPE 1 : poids -----
  $$('.barky-weight-btn:not(.barky-flavor-btn)').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.weight = btn.dataset.weight;
      $$('.barky-weight-btn:not(.barky-flavor-btn)').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      const profile = cfg.weightProfiles[state.weight] || {};
      const sum = $('[data-weight-summary]');
      if (sum) sum.innerHTML = '<strong>' + profile.label + '</strong> — ' + profile.detail;
      state.recoCount = profile.reco || profile.boxes[0];
      state.count = state.recoCount;
      renderBundles(); updateVariant(); updatePrices(); applyAutoCadence();
    });
  });

  function selectBox(count) {
    state.count = count;
    $$('.barky-bundle-card').forEach((b) =>
      b.setAttribute('aria-pressed', String(Number(b.dataset.count) === count)));
    updateVariant(); updatePrices(); applyAutoCadence();
  }

  function updateVariant() {
    const t = tier(state.count); const inp = $('#barky-input-variant');
    if (!t || !inp) return;
    const b = state.flavor === 'boeuf';
    const oneTime = b ? t.variantIdB : t.variantIdP;
    const abo = b ? t.subVariantIdB : t.subVariantIdP;
    inp.value = (state.frequency === 'subscription' && abo) ? abo : (oneTime || '');

    // profil de poids -> propriété de ligne, lue par le tiroir du panier
    const w = document.querySelector('#barky-input-weight');
    if (w) w.value = state.weight || '';
  }

  // ----- ÉTAPE 2 : goût -----
  $$('.barky-flavor-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.flavor = btn.dataset.flavor;
      $$('.barky-flavor-btn').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      updateVariant();
    });
  });

  // ----- ÉTAPE 3 : fréquence -----
  $$('input[name="barky-freq"]').forEach((input) => {
    input.addEventListener('change', () => {
      state.frequency = input.value; syncFreqVisuals(); updateVariant(); updateSellingPlan();
    });
  });

  function syncFreqVisuals() {
    const subCard = $('.barky-sub-card');
    if (subCard) subCard.classList.toggle('is-open', state.frequency === 'subscription');
  }

  const cadenceSelect = $('[data-cadence-select]');
  if (cadenceSelect) {
    cadenceSelect.addEventListener('change', () => { state.cadence = cadenceSelect.value; updateSellingPlan(); });
  }

  function updateSellingPlan() {
    const inp = $('#barky-input-selling-plan');
    if (!inp) return;
    inp.value = (state.frequency === 'subscription' && state.cadence && cfg.subSellingPlans) ? (cfg.subSellingPlans[state.cadence] || '') : '';
  }

  // ----- Pré-sélection auto de la fréquence (taille x boîtes), plafond 3 mois -----
  function autoCadenceValue() {
    const af = cfg.autoFrequency;
    if (af && state.weight && af[state.weight]) {
      const v = af[state.weight][String(state.count)];
      if (v) return v;
    }
    return 'quarterly'; // regle generale : jamais plus de 3 mois
  }
  function applyAutoCadence() {
    if (!state.weight || state.count == null) return;
    state.cadence = autoCadenceValue();
    const sel = $('[data-cadence-select]');
    if (sel) sel.value = state.cadence;
    updateSellingPlan();
  }

  function updatePrices() {
    const t = tier(state.count); if (!t) return;
    const total = t.total;
    const compare = t.compareTotal || total;
    const k = String(state.count);
    const sub = (cfg.subPrices && cfg.subPrices[k] != null)
      ? cfg.subPrices[k]
      : Math.round(total * (1 - cfg.subscriptionDiscount) * 100) / 100;
    const save = Math.round((compare - sub) * 100) / 100;
    const oneoffEl = $('[data-freq-price="oneoff"]'); if (oneoffEl) oneoffEl.textContent = eur(total);
    const oneoffCmp = $('[data-oneoff-compare]'); if (oneoffCmp) oneoffCmp.textContent = t.compareTotal ? eur(t.compareTotal) : '';
    const subEl = $('[data-freq-price="subscription"]'); if (subEl) subEl.textContent = eur(sub);
    const subCmp = $('[data-sub-compare]'); if (subCmp) subCmp.textContent = eur(compare);
    const savEl = $('[data-sub-savings]'); if (savEl) savEl.textContent = (cfg.savingsPrefix || 'Économisez') + ' ' + eur(save);
  }

  // ----- SOUMISSION (drawer optimiste, comme v5) -----
  const cta = $('#barky-cta');
  const drawer = document.querySelector('cart-drawer');
  if (cta && drawer && typeof drawer.open === 'function') {
    cta.addEventListener('click', function () { if ($('#barky-input-variant').value) drawer.open(cta); });
  }

  // ----- INIT -----
  syncFreqVisuals(); updateSellingPlan();
  const dft = $('.barky-weight-btn[data-weight="' + (cfg.defaultWeight || 'medium') + '"]');
  if (dft) dft.click();
})();
